// Constants
import { PlannerTheme } from "@ms/uno-constants/lib/local/ThemeConstants";
// Utilities
import { useContext } from "react";
import { PlannerThemeContext } from "../contexts/PlannerThemeContext";
/**
 * Hook to get planner theme type from context
 * Returns Light theme as fallback when used outside PlannerThemeContextProvider (e.g., in error scenarios before app initialization)
 */ export function usePlannerTheme() {
    const theme = useContext(PlannerThemeContext);
    if (!theme) {
        // Log warning when used without context provider (e.g., in error views before app initialization)
        console.warn("usePlannerTheme: No PlannerThemeContext found, falling back to Light theme");
    }
    // Return Light theme as fallback for error scenarios where context isn't available such as in bootstrap stage when app context init fails
    return theme ?? PlannerTheme.Light;
}
